
import React, { useContext } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form } from "formik";
import { TextField, MenuItem, Autocomplete } from "@mui/material";
import { WarehouseContext } from "../../data/warehouse/WarehouseContext";
import { PersonelContext } from "../../data/personel/PersonelContext";
import CapitalizedFormikField from "../../components/CapitalizedFormikField";
import { useValidations } from "../../data/ValidationContext";

const ShelfAddModal = ({ isOpen, onClose, warehouseId }) => {
  const { warehouses, addShelf } = useContext(WarehouseContext);
  const { personelList } = useContext(PersonelContext);
  const { vs_shelf } = useValidations();

  if (!warehouseId) return null;
  const warehouse = warehouses.find((w) => w.id === warehouseId);
  if (!warehouse) return null;

  const initialValues = {
    name: "",
    status: "Aktif",
    personelId: null,
  };

  const statusOptions = ["Aktif", "Pasif"];

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Formik
        initialValues={initialValues}
        validationSchema={vs_shelf}
        onSubmit={(values) => {
          // Raf adı benzersiz kontrol
        

          // Raf ekleme
          addShelf(warehouseId, {
            id: Date.now(),
            name: values.name,
            status: values.status,
            personelId: values.personelId,
            createdAt: new Date(),
            updatedAt: new Date(),
          });

          onClose();
        }}
      >
        {({ values, touched, errors, handleChange, setFieldValue, setFieldTouched }) => (
          <Form>
            <Modal.Header closeButton>
              <Modal.Title>Raf Ekle</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="d-flex flex-column gap-3">
                {/* Raf Adı */}
                <CapitalizedFormikField
                  name="name"
                  label="Raf Adı"
                  variant="outlined"
                  size="small"
                  fullWidth
                 
                  error={touched.name && !!errors.name}
                  helperText={touched.name && errors.name}
                />

                {/* Durum */}
                <CapitalizedFormikField
                  select
                  name="status"
                  label="Durum"
                  value={values.status}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  error={touched.status && !!errors.status}
                  helperText={touched.status && errors.status}
                >
                  {statusOptions.map((status) => (
                    <MenuItem key={status} value={status}>
                      {status}
                    </MenuItem>
                  ))}
                </CapitalizedFormikField>

                {/* Personel Seçimi */}
                <Autocomplete
                  options={personelList}
                  getOptionLabel={(option) => option.fullName}
                  value={personelList.find((p) => p.id === values.personelId) || null}
                  onChange={(e, newValue) => setFieldValue("personelId", newValue ? newValue.id : null)}
                  onBlur={() => setFieldTouched("personelId", true)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Personel Seç"
                      size="small"
                      fullWidth
                      error={touched.personelId && !!errors.personelId}
                      helperText={touched.personelId && errors.personelId}
                    />
                  )}
                />
              </div>
            </Modal.Body>

            <Modal.Footer>
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                İptal
              </button>
              <button type="submit" className="btn btn-primary">
                Kaydet
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ShelfAddModal;
